import { connect } from 'react-redux'
import { getPrintOrientation } from 'redux/print/selectors'
import { PrintSheet } from './PrintSheet.jsx'
import { getDefaultScale } from 'redux/canvas/selectors'
import { getPrintMediaTitle } from 'redux/print/selectors'

export const mapStateToProps = (state, props) => ({
    printOrientation: getPrintOrientation(state),
    forcedScale: props.forcedScale * getDefaultScale(state, 'print'),
    title: getPrintMediaTitle(state),
})

export const PrintSheetContainer = connect(
    mapStateToProps,
)(PrintSheet)
